import React, { useMemo, useState } from 'react';
import { RoofingCalculator } from './components/RoofingCalculator';
import { CompetitorComparison } from './pages/CompetitorComparison';
type Page = 'calculator' | 'comparison';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('calculator');
  const [squares, setSquares] = useState<number>(30);
  const [sellingPrice, setSellingPrice] = useState<number>(550);
  if (currentPage === 'comparison') {
    return <CompetitorComparison squares={squares} sellingPrice={sellingPrice} onBack={() => setCurrentPage('calculator')} data-id="element-0" />;
  }
  return <RoofingCalculator squares={squares} setSquares={setSquares} sellingPrice={sellingPrice} setSellingPrice={setSellingPrice} onViewComparison={() => setCurrentPage('comparison')} data-id="element-1" />;
}